<template>
    <section>
        <PageTitle title="Feedback" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/feedbacks',title:'Feedback'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5>Feedback</h5>
                    </div>
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-3">
                                <AllRestaurants
                                    :placeholder="'Select Restaurant'"
                                    :updateSelectedRestaurant="selectedRestaurant"
                                    :return-value="''"
                                    @update:selectedRestaurantId="fetchBranchesOfRestaurant"
                                />
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Branches</label>
                                    <select id="filter2" v-model="selectedBranch" class="form-control" >
                                        <option value="">Select Branch</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id+'_branchchoose'">
                                            {{branch.areasByAreaId.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Customer Name</label>
                                    <input placeholder="Customer Name..." id="filter3" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Waiter</label>
                                    <input placeholder="Waiter Name..." id="filter4" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Created At</label>
                                    <input id="filter5" type="text" readonly="readonly" placeholder="Search By Date Range" class="form-control date_picker"/>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <ul class="list-inline" style="margin-top: 25px">
                                    <li>
                                        <button class="btn btn-md btn-primary search_feedback">Search</button>
                                    </li>
                                    <li>
                                        <button class="btn btn-md btn-danger reset_feedback">Reset</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <hr/>
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-hover" id="fdTable">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Restaurant</th>
                                    <th>Branch</th>
                                    <th>Customer Name</th>
                                    <th>Customer Phone</th>
                                    <th>Average Score</th>
                                    <th>Assigned Table</th>
                                    <th>Waiter</th>
                                    <th>Created at</th>
                                    <th class="text-center"><i class="fa fa-bolt"></i></th>
                                </tr>
                                </thead>
                                <tbody>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="show_customer" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="show_customer_modalLabel">Customer Info</h4>
                    </div>
                    <div class="modal-body">
                        <div class="col-md-4 pull-right" v-if="customer.averageScore!==null">
                            <div class="text-center">
                                Average Response(<b>{{parseFloat(customer.averageScore).toFixed(2)}}%</b>)<br>
                                <div>
                                <img :src="averageResponse()" style='max-width: 70px;'>
                                <h3>{{averageResponseEmoticon}}</h3>
                                </div>
                            </div>
                        </div>
                        <strong>{{(customer.customerName!==null) ? customer.customerName : "N/A"}}</strong> <br>
                        Phone: <b>{{(customer.customerPhone!==null) ? customer.customerPhone : "N/A"}}</b><br>
                        Email: <b>{{(customer.customerEmail!==null) ? customer.customerEmail : "N/A"}}</b><br>
                        Address: <b>{{(customer.customerAddress!==null) ? customer.customerAddress : "N/A"}}</b><br>
                        <br><br>
                        <!-- <hr> -->
                        <table class="table table-bordered table-hover table-stripped">
                            <thead>
                                <tr>
                                    <th class="text-center">Question</th>
                                    <th class="text-center">Question Type</th>
                                    <th class="text-center">Answer</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(questions, questionIndex) in customer.branchFeedbackAnswers">
                                    <tr :key="questionIndex + '_' + questions.id">
                                        <td class="text-center" style="width:30%;">{{questions.question}}</td>
                                        <td class="text-center">{{questions.questionType}}</td>
                                        <td v-if="questions.questionType!=='emoticon'" class="text-center">{{questions.answer}}</td>
                                        <td v-else style="position:relative; overflow:hidden">
                                            <div class="emoticon-div">
                                                <img src="/img/emoji/mad.png" :class="{'makeGray': questions.answer!=='Dissatisfied'}" style='max-width: 50px; padding:5px;'>
                                                <div>Dissatisfied</div>
                                            </div>
                                            
                                            <div class="emoticon-div">
                                                <img src="/img/emoji/confused.png" :class="{'makeGray': questions.answer!=='Neutral'}" style='max-width: 50px; padding:5px;'>
                                                <div>Neutral</div>
                                            </div>
                                            
                                            <div class="emoticon-div">
                                                <img src="/img/emoji/smiling.png" :class="{'makeGray': questions.answer!=='Satisfied'}" style='max-width: 50px; padding:5px;'>
                                                <div>Satisfied</div>
                                            </div>
                                            
                                            <div class="emoticon-div">
                                                <img src="/img/emoji/happy.png" :class="{'makeGray': questions.answer!=='Awesome'}" style='max-width: 50px; padding:5px;'>
                                                <div>Awesome</div> 
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageTitle from "../components/layout_components/PageTitle";
    import User from '@/services/User'
    import AllRestaurants from "../components/restaurants/AllRestaurants";
    export default {
        name: "Feedback",
        components: {AllRestaurants, PageTitle},
        data() {
            return {
                selectedRestaurant: "",
                selectedBranch: "",
                selectedQuestionType: "",
                loggedInRole: "",
                restaurants: [],
                branches: [],
                questions: [],
                allEmotions: [],
                customer: {},
                responses: [{key:'happy',text:'Happy'}, {key:'smiling',text:'Smiling'}, {key:'confused',text:'Confused'},
                    {key:'angry',text:'Angry'},{key:'mad',text:'Mad'}
                ],
                averageResponseEmoticon:''
            }
        },
        created() {
            User.fetchUserRoles().then(role => {
                this.loggedInRole = role;
                if(role === 'ROLE_ADMIN' || role === 'ROLE_ADMIN'){
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                        this.restaurants = resp.data;
                        console.log(this.restaurants);
                    });
                }else if(role === 'ROLE_USER'){
                    this.selectedRestaurant = this.$store.state.user.restaurant.id;
                    this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name});
                    this.fetchBranchesOfRestaurant();
                }
            });
        },
        updated() {
            $(".m_tip").tooltip({placement: 'right'});
        },
        mounted() {
            let processingURL = this.$store.state.mainAppURL + "feedback/responses";
            const self = this;
            let fdTable = $('#fdTable').DataTable({
                "processing": true,
                "serverSide": true,
                "autoWidth": false,
                "pagingType": "simple",
                "lengthMenu": [10, 25, 50, 100, 250],
                'language': {
                    "infoFiltered": "",
                    //'loadingRecords': 'Please wait - loading...',
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                        d.restaurant_id=self.selectedRestaurant;
                        d.branch_id= self.selectedBranch;
                        return JSON.stringify( d );
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr) => {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(fdTable);
                      }
                    }
                },
                "columnDefs": [
                    { "orderable": false, "targets": [0,1,2,3,4,5,6,7,8,9] },
                    { 'className': "text-center", 'aTargets': [0,1,2,3,4,5,6,7,8,9]},
                ],
                "columns": [
                    {"data": "id", "name": "ID"},
                    { "data": "branchFeedback.branch.restaurantsByRestaurantId.name","name":"restaurant_name" },
                    { "data": "branchFeedback.branch.areasByAreaId.name","name":"branch_area" },
                    { "data": "customerName","name":"Customer Name" },
                    {
                        "data": "customerPhone",
                        "name":"customerPhone",
                        "render": function (data) {
                            if(data===null){
                                return "N/A";
                            }
                            return data;
                        }
                    },
                    {
                        "data": "averageScore",
                        "name": "averageScore",
                        "render": self.averageScoreLabel
                    },                    
                    {
                        "data": "tableNumber",
                        "name": "tableNumber",
                        "render": function (data,type,row){
                            if(row.tables===null){
                                return "N/A"
                            }
                            return row.tables.name;
                        }
                    },
                    {
                        "data": "waiter",
                        "name": "waiter",
                        "render": function (data, type, row){
                            if(row.waiters===null){
                                return "N/A"
                            }
                            return row.waiters.name;
                        }
                    },
                    {
                        "data": "created",
                        "name":"created",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "actions",
                        "render": function(data, type, row){
                            return '<a data-row-id="'+row.id+'" class="btn btn-xs btn-primary view_btn" href="javascript:void(0)">View</a>';
                        },
                        "name":"actions"
                    }
                ],
                "drawCallback": function( settings ) {
                    $(".m_tip").tooltip({placement: 'right'});
                    $(".view_btn").click( function() {
                        let feedbackId = $(this).attr("data-row-id");
                        self.fetchDataForCustomer(feedbackId);
                    });
                }
            });
            $.fn.dataTable.ext.errMode = 'none';
            $(".search_feedback").click(function(){
                fdTable.column(3).search( $("#filter3").val() )
                fdTable.column(7).search( $("#filter4").val() )
                fdTable.column(8).search( $('#filter5').val() )
                fdTable.draw();
            });
            $(".reset_feedback").click(function(){
                for(let i=0; i < 5; i++){
                    $("#filter" + (i+1)).val( '' );
                    fdTable.column(i).search( '' );
                }
                fdTable.column(7).search( '' );
                fdTable.column(8).search( '' );
                self.selectedBranch = "";
                if(self.loggedInRole === 'ROLE_ADMIN' || self.loggedInRole === 'ROLE_MANAGER') {
                  self.selectedRestaurant = "";
                }

                self.branches = [];
                fdTable.draw();
            });
            let fdTableFilterSelector = $("#fdTable_filter input");
            fdTableFilterSelector.unbind();
            fdTableFilterSelector.keyup(function (e) {
                if(e.keyCode === 13) {
                    fdTable.search($(this).val()).draw();
                }
            });
            $('.date_picker').daterangepicker({
                format: 'YYYY-MM-DD',
            }).on('apply.daterangepicker', function(ev, picker) {
                $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
            }).on('cancel.daterangepicker', function(ev, picker) {
                $(this).val('');
            });
        },
        methods: {
            fetchBranchesOfRestaurant: function (event) {
                this.selectedRestaurant = event;
                let params = new URLSearchParams();
                params.append("restaurant_id", this.selectedRestaurant);
                if(this.selectedRestaurant !== ""){
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                        console.log(resp.data);
                        this.branches = resp.data;
                    });
                }else{
                    this.branches = [];
                }
                this.selectedBranch = "";
            },
            getQuestions() {
                this.questions = [];
                this.$http.get(this.$store.state.mainAppURL + "feedback/response_questions").then(resp => {
                   this.questions = resp.data;
                })
            },
            fetchDataForCustomer(response_id){
                this.customer = {};
                this.$http.get(this.$store.state.mainAppURL + "feedback/response/"+response_id).then(resp => {
                    this.customer = resp.data;
                    $("#show_customer").modal("show");
                })
            },
            getEmoticonPath(emoticonName){
                const basePath= '/img/emoji/'
                switch(emoticonName){
                    case 'Dissatisfied':
                        return basePath + 'mad.png'
                    case 'Neutral':
                        return basePath + 'confused.png'
                    case 'Satisfied':
                        return basePath + 'smiling.png'
                    case 'Awesome':
                        return basePath + 'happy.png'
                }
            },
            averageResponse: function(){
                let score=parseInt(this.customer.averageScore)
                const basePath= '/img/emoji/'
                if(score<=25){
                    this.averageResponseEmoticon="Dissatisfied"
                    return basePath + 'mad.png'
                }else if(score>25 && score<=50){
                    this.averageResponseEmoticon="Netural"
                    return basePath + 'confused.png'
                }else if(score>50 && score<=75){
                    this.averageResponseEmoticon="Satisfied"
                    return basePath + 'smiling.png'
                }else if(score>75){
                    this.averageResponseEmoticon="Awesome"
                    return basePath + 'happy.png'
                }                 
            },
            averageScoreLabel: function(data, type, row){
                if(data===null){
                    return "N/A"
                }
                else if(data<=25){return "<span class='label label-danger'>"+data.toFixed(2)+"</span>"}
                else if(data>25 && data<=50){return "<span class='label label-warning'>"+data.toFixed(2)+"</span>"}
                else if(data>50 && data<=75){return "<span class='label label-info'>"+data.toFixed(2)+"</span>"}
                else if(data>75){return "<span class='label label-success'>"+data.toFixed(2)+"</span>"}                
            }
        }
    }
</script>

<style scoped>
.center-cont{
   display: flex;
    justify-content: center;
}
.emoji_badge{
    position: absolute;
    top: 3px;
    display: inline-block;
    font-size: 75%;
    line-height: 0.8rem;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    color: rgb(255, 255, 255);
    user-select: none;
    font-weight: bolder;
    padding: 0.3em 0.6rem;
    border-radius: 10rem;
    background: rgb(34, 139, 230);
}
#c-info dd{
    background: #ccc;
    padding: 10px;
    margin-bottom: 10px;
    border: solid 1px;
}
.makeGray{
    filter: grayscale(100%);
}
.emoticon-div {
    float:left;
    margin: 5%;
    margin-bottom: 1px;
    margin-top: 1px;
}
</style>
